import Axios from "axios";
import { checkArguments, createAccountToken, createChangePasswordToken } from "./utils";
import { countries } from "./countries";
import settings from "../config_settings.json";

let API_Server = "";
let API_Server_MY = "https://my.icareus.com";

if (settings.API_Server_Number === 1) {
	API_Server = "https://suite.icareus.com";
} else if (settings.API_Server_Number === 2) {
	API_Server = "https://suite.icareus.com";
} else if (settings.API_Server_Number === 3) {
	API_Server = "https://suiterc.icareus.com";
}
const findSubOrganizationSecret = async (organizationId, key, subOrganizationId) => {
	console.log("organizationId, key, subOrganizationId", organizationId, key, subOrganizationId);
	if (organizationId * 1 === subOrganizationId * 1) {
		let subKey = {};
		subKey.secret = settings.organization.key;

		return subKey;
	}
	const res = await getChannels(organizationId, key);
	return Object.values(res?.data?.organization?.subOrganizations).find(
		(el) => el.organizationId === subOrganizationId * 1
	);
};

// Get all category names and id:s
const getCategories = async (organizationId, key, lang, user) => {
	if (checkArguments(organizationId, key, lang)) {
		try {
			const catResponse = await Axios.get(
				`${API_Server}/api/archive?action=getGroups&organizationId=${organizationId}&userId=${
					user?.userId || 0
				}&userToken=${user?.userToken || ""}&languageId=${lang}&token=${key}&groupTypeName=Folders`
			);
			console.log("getCategories: ", catResponse);
			return catResponse.data.groupItems;
		} catch (err) {
			console.log(err);
		}
	}
};
// get Latest Assets
const getLatestAssets = async (organizationId, token, languageId, limit) => {
	if (checkArguments(organizationId, token, languageId)) {
		try {
			const itemResponse = await Axios.get(
				`${API_Server}/api/publishing?organizationId=${organizationId}&languageId=${languageId}&limit=${
					limit ? limit : 10
				}&onlyVideos=true&action=getLatestAssets&token=${token}`
			);
			console.log("get latest Asset: ", itemResponse);
			return itemResponse.data;
		} catch (err) {
			console.log(err);
		}
	}
};
const getTrendingAssets = async (organizationId, token, languageId, limit, days) => {
	if (checkArguments(organizationId, token, languageId)) {
		try {
			const res = await Axios.get(
				`${API_Server}/api/publishing?organizationId=${organizationId}&amount=${
					limit ? limit : 10
				}&days=${days ? days : 7}0&onlyVideos=true&action=getMostPopular&token=${token}`
			);
			console.log("get trending Asset: ", res);
			const res1 = res.data.assets.map((el) => el.asset);

			return res1;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get assets that are listed in groupItemId -string
const getSeries = async (organizationId, key, languageId, user, assetProperty) => {
	console.log(organizationId, key, languageId, user, assetProperty, "assetProperty");

	if (checkArguments(organizationId, key, languageId)) {
		try {
			const seriesResponse = await Axios.get(`${API_Server}/api/archive?action=getGroups`, {
				params: {
					organizationId,
					languageId,
					groupTypeName: "Series",
					...(user?.userId ? { userId: user?.userId } : {}),
					...(user?.userToken ? { userToken: user?.userToken } : {}),
					...(assetProperty ? { assetProperty: assetProperty } : {}),
				},
			});

			console.log("getSeries: ", seriesResponse);
			return seriesResponse.data.groupItems;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get subCategories with groupItemId string (single or separated by comma)
const getSubCategories = async (organizationId, token, groupItemId, lang, user) => {
	if (checkArguments(organizationId, token, groupItemId, lang)) {
		console.log(organizationId, token, groupItemId, lang);
		try {
			const catResponse = await Axios.get(
				`${API_Server}/api/archive?action=getGroup&organizationId=${organizationId}&groupItemIds=${groupItemId}&userId=${
					user?.userId || 0
				}&userToken=${user?.userToken || ""}&languageId=${lang}&token=${token}&showHidden=true`
			);
			console.log("getSubCategories: ", catResponse);
			return catResponse.data.data;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get all category names and id:s with root category id
const getRootSubCategories = async (organizationId, key, lang, groupItemId, user) => {
	if (checkArguments(organizationId, groupItemId, key, lang, groupItemId)) {
		try {
			const catResponse = await Axios.get(
				`${API_Server}/api/archive?action=getGroups&organizationId=${organizationId}&userId=${
					user?.userId || 0
				}&userToken=${
					user?.userToken || ""
				}&languageId=${lang}&token=${key}&groupItemId=${groupItemId}`
			);
			console.log("getRootSubCategories: ", catResponse);
			return catResponse.data.groupItems;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get assets that are listed in groupItemId -string
const getAssets = async (organizationId, groupItemId, token, languageId, assetProperty, user) => {
	if (checkArguments(organizationId, groupItemId, token, languageId)) {
		try {
			const itemResponse = await Axios.get(`${API_Server}/api/publishing/getAssets?version=06`, {
				params: {
					organizationId,
					languageId,
					groupItemId,
					token,
					...(user?.userId ? { userId: user?.userId } : {}),
					...(user?.userToken ? { userToken: user?.userToken } : {}),
					...(assetProperty ? { assetProperty: assetProperty } : {}),
				},
			});

			console.log("getAssets: Editor ", itemResponse);
			return itemResponse.data.assets;
		} catch (err) {
			console.log(err);
		}
	}
};

// get upcomingEvents based on currentTime
const getUpcomingEvents = async (organizationId, limit, from, to) => {
	try {
		const currentTime = Date.now();
		let url = `${API_Server}/api/events?action=getEvents&version=02&organizationId=${organizationId}&end=${limit}&categoryIds=${settings.filteredEventCategoryId}`;
		// let url = `${API_Server}/api/events?action=getEvents&version=02&organizationId=${organizationId}&end=${limit} `;

		if (from && !to) {
			url = `${url}&from=${from}`;
		}

		if (from && to) {
			url = `${url}&from=${from}&to=${to}`;
		}
		if (!from && to) {
			url = `${url}&to=${to}`;
		}
		if (!from && !to) {
			url = `${url}&from=${currentTime}`;
		}

		const res = await Axios.get(url);
		console.log(`res upcoming eventsbeta`, res);

		return res;
	} catch (error) {
		console.log(error);
	}
};
export const getPastEvents = async (organizationId, limit) => {
	try {
		const currentTime = Date.now();
		let url = `${API_Server}/api/events?action=getEvents&version=02&organizationId=${organizationId}&end=${limit}&to=${currentTime}&categoryIds=${settings.filteredEventCategoryId}`;
		// let url = `${API_Server}/api/events?action=getEvents&version=02&organizationId=${organizationId}&end=${limit}&to=${currentTime} `;

		const res = await Axios.get(url);
		console.log(`res pasts eventsbeta`, res);

		return res;
	} catch (error) {
		console.log(error);
	}
};

// get upcomingEvents based on currentTime
const getLiveNowEvents = async (organizationId) => {
	try {
		let url = `${API_Server}/api/events?action=getLiveEvents&organizationId=${organizationId}&includeSubOrganizationEvents=true&categoryIds=${settings.filteredEventCategoryId}`;
		// let url = `${API_Server}/api/events?action=getLiveEvents&organizationId=${organizationId}&includeSubOrganizationEvents=true`;

		const res = await Axios.get(url);
		console.log(`getLiveNowEvents: `, res);

		return res;
	} catch (error) {
		console.log(error);
	}
};

// Get all events
const getAllEvents = async (organizationId, categoryId, limit, from, to) => {
	try {
		let url;
		if (categoryId) {
			url = `${API_Server}/api/events?action=getEvents&version=02&organizationId=${organizationId}&categoryIds=${categoryId}&end=${limit}`;
		} else {
			url = `${API_Server}/api/events?action=getEvents&version=02&organizationId=${organizationId}&end=${limit}`;
		}
		if (from && !to) {
			url = `${url}&from=${from}`;
		}

		if (from && to) {
			url = `${url}&from=${from}&to=${to}`;
		}
		if (!from && to) {
			url = `${url}&to=${to}`;
		}

		const res = await Axios.get(url);

		return res;
	} catch (error) {
		console.log(error);
	}
};
// Get all events
const getAllEventsBeta = async (organizationId, categoryId, limit, from, to) => {
	try {
		let url;
		if (categoryId) {
			url = `https://suiterc.icareus.com/api/events?action=getEvents&version=02&organizationId=${organizationId}&categoryIds=${categoryId}&end=${limit}`;
		} else {
			url = `https://suiterc.icareus.com/api/events?action=getEvents&version=02&organizationId=${organizationId}&end=${limit}`;
		}
		if (from && !to) {
			url = `${url}&from=${from}`;
		}

		if (from && to) {
			url = `${url}&from=${from}&to=${to}`;
		}

		const res = await Axios.get(url);

		return res;
	} catch (error) {
		console.log(error);
	}
};

const getRecordings = async (organizationId, assetId, token) => {
	try {
		const res = await Axios.get(
			`${API_Server}/api/publishing/getAssetPlaybackUrls?version=03&organizationId=${organizationId}&assetId=${assetId}&token=${token}`
		);
		console.log(res, "recordings");
		return res.data;
	} catch (error) {
		console.log(error);
	}
};

const getSingleEvent = async (organizationId, eventId) => {
	try {
		const res = await Axios.get(
			`${API_Server}/api/events?action=getEvent&version=02&organizationId=${organizationId}&eventId=${eventId}`
		);
		console.log(res);
		return res.data;
	} catch (error) {}
};

const getUpcomingEventsBeta = async (organizationId, limit, from, to) => {
	try {
		const currentTime = Date.now();
		let url = `https://suiterc.icareus.com/api/events?action=getEvents&version=02&organizationId=${organizationId}&end=${limit}`;

		if (from && !to) {
			url = `${url}&from=${from}`;
		}

		if (from && to) {
			url = `${url}&from=${from}&to=${to}`;
		}
		if (!from && !to) {
			url = `${url}&from=${currentTime}`;
		}

		const res = await Axios.get(url);
		console.log(`res upcoming eventsbeta`, res);

		return res;
	} catch (error) {
		console.log(error);
	}
};
const getEventsCategoriesBeta = async (organizationId) => {
	try {
		const res = await Axios.get(
			`https://suiterc.icareus.com/api/events?action=getCategories&version=02&organizationId=${organizationId}`
		);
		return res;
	} catch (error) {
		console.log(error);
	}
};

const getEventsCategories = async (organizationId) => {
	try {
		const res = await Axios.get(
			`${API_Server}/api/events?action=getCategories&version=02&organizationId=${organizationId}`
		);
		return res;
	} catch (error) {
		console.log(error);
	}
};
// this is actual not channel but suborg
const getChannels = async (organizationId, secret) => {
	try {
		// const res = await Axios.get(
		//   `${API_Server}/api/organization?action=getOrganization&version=04&organizationId=69922&includeSubOrganizations=true`
		// );
		let token = secret;
		const res = await Axios.get(
			`${API_Server}/api/organization?action=getOrganization&version=04&organizationId=${organizationId}&includeSubOrganizations=true&token=${token}`
		);
		return res;
	} catch (error) {
		console.log(error);
	}
};
const getChannelsBeta = async (organizationId, secret) => {
	try {
		// const res = await Axios.get(
		//   `https://suiterc.icareus.com/api/organization?action=getOrganization&version=04&organizationId=3409909&includeSubOrganizations=true`
		// );
		let token = secret ? secret : "tNtSx9xU06";
		const res = await Axios.get(
			`https://suiterc.icareus.com/api/organization?action=getOrganization&version=04&organizationId=${organizationId}&includeSubOrganizations=true&token=${token}`
		);
		return res;
	} catch (error) {
		console.log(error);
	}
};

// now fething actual channel
export const organizationAllChannel = async (organizationId) => {
	// https://suite.icareus.com/api/channels?action=getChannels&version=04&orderBy=logicalChannelNumber&organizationId=206695809&limit=10
	try {
		const res = await Axios.get(
			`${API_Server}/api/channels?action=getChannels&version=04&organizationId=${organizationId}&orderBy=logicalChannelNumber&limit=10`
		);
		return res;
	} catch (error) {
		console.log(error);
	}
};

// now fething actual channel
export const organizationChannelBasedonChannelId = async (organizationId, channelId) => {
	try {
		// we are hardcoding channelId here
		const res = await Axios.get(
			`${API_Server}/api/channels?action=getChannel&version=04&organizationId=${organizationId}&lcId=${
				channelId ? channelId : 206696946
			}`
		);
		return res?.data?.channel;
	} catch (error) {
		console.log(error);
	}
};
export const organizationEventPerChannel = async (organizationId, channelId, from) => {
	try {
		// https://suite.icareus.com/api/channels?action=getEvents&version=04&organizationId=206695809&lcId=206696946&from=1668729600000
		const res = await Axios.get(
			`${API_Server}/api/channels?action=getEvents&version=04&organizationId=${organizationId}&lcId=${channelId}&from=${
				from ? from : Date.now()
			}`
		);
		return res;
	} catch (error) {
		console.log(error);
	}
};
// Get items that are listed in groupItemId -string
const getSimiliar = async (
	organizationId,
	groupItemId,
	token,
	lang,
	assetProperty,
	user,
	limit
) => {
	if (checkArguments(organizationId, groupItemId, token, lang, assetProperty)) {
		try {
			let limitValue = limit ? limit : 10;
			const itemResponse = await Axios.get(
				`${API_Server}/api/publishing/getAssets?version=06&organizationId=${organizationId}&userId=${
					user?.userId || 0
				}&userToken=${user?.userToken || ""}&assetProperty=${
					assetProperty || ""
				}&orderBy=publishStart&limit=${limitValue}&languageId=${lang}&groupItemId=${groupItemId}&token=${token}`
			);
			console.log("getSimiliar: ", itemResponse);
			return itemResponse.data.assets;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get items that are listed in groupItemId -string
const getAsset = async (organizationId, assetId, token, lang, assetProperty, user) => {
	if (checkArguments(organizationId, assetId, token, lang)) {
		try {
			const itemResponse = await Axios.get(
				`${API_Server}/api/publishing/getAsset?version=03&organizationId=${organizationId}&userId=${
					user?.userId || 0
				}&userToken=${user?.userToken || ""}&assetProperty=${
					assetProperty || ""
				}&languageId=${lang}&assetId=${assetId}&token=${token}`
			);
			console.log("getAsset asset: ", itemResponse);
			return itemResponse.data;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get serie episodes
const getEpisodes = async (organizationId, groupItemId, token, lang, assetProperty, user) => {
	if (checkArguments(organizationId, groupItemId, token, lang)) {
		try {
			const episodeResponse = await Axios.get(
				`${API_Server}/api/publishing?action=getAssets&version=06&organizationId=${organizationId}&userId=${
					user?.userId || 0
				}&userToken=${user?.userToken || ""}&assetProperty=${
					assetProperty || ""
				}&languageId=${lang}&token=${token}&groupItemId=${groupItemId}&series=false`
			);
			console.log("getEpisodes: ", episodeResponse);
			return episodeResponse.data.assets;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get promoted content
const getPromo = async (
	organizationId,
	groupItemId,
	token,
	lang,
	assetProperty,
	user,
	limitValue
) => {
	if (checkArguments(organizationId, groupItemId, token, lang)) {
		try {
			let limit = limitValue ? limitValue : 3;

			const promoResponse = await Axios.get(
				`${API_Server}/api/publishing?action=getAssets&version=05&organizationId=${organizationId}&userId=${
					user?.userId || 0
				}&userToken=${user?.userToken || ""}&assetProperty=${
					assetProperty || ""
				}&languageId=${lang}&orderBy=publishStart&limit=${limitValue}&token=${token}&groupItemId=${groupItemId}&series=false`
			);
			console.log("getPromo: ", promoResponse);
			return promoResponse;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get banner items
const getBanner = async (organizationId, groupItemId, token, lang, user) => {
	if (checkArguments(organizationId, groupItemId, token, lang)) {
		try {
			const bannerResponse = await Axios.get(
				`${API_Server}/api/publishing?action=getBanners&version=05&organizationId=${organizationId}&userId=${
					user?.userId || 0
				}&userToken=${
					user?.userToken || ""
				}&languageId=${lang}&token=${token}&groupItemId=${groupItemId}&series=false`
			);
			console.log("getBanner: ", bannerResponse);
			return bannerResponse.data.assets;
		} catch (err) {
			console.log(err);
		}
	}
};

// Authenticate user
const authenticateUser = async (organizationId, email, password, role) => {
	try {
		let url = `${API_Server_MY}/api/login?action=authenticate`;

		const authResponse = await Axios.get(url, {
			params: {
				organizationId,
				eMail: email,
				password: password,
				...(role && role ? { role: "Super Administrator" } : { role: "ismsubscriber" }),
			},
		});
		// console.log("Authentication: ", authResponse);
		return authResponse;
	} catch (err) {
		console.log(err);
	}
};
export const selfDeleteUser = async (userId, userToken) => {
	try {
		let url = `${API_Server_MY}/api/user?action=removeSelf`;

		let params = {
			organizationId: settings.organization.organizationId,
			userId,
		};
		let headers = {
			"Content-Type": "application/json",
			userToken,
		};

		// Make the DELETE request with axios or your preferred HTTP client
		const response = await Axios.get(url, { headers, params });

		// Handle the response as needed
		console.log(response.data);

		return response?.data;
	} catch (error) {
		console.log(error);
	}
};

const registerUser = async (organizationId, inputs, role) => {
	console.log("organizationId", organizationId);
	console.log("inputs", inputs);

	let extraUserSettings = [];

	if (inputs?.ORGANIZATIONNAME?.value) {
		extraUserSettings.push({
			type: "text",
			value: inputs?.ORGANIZATIONNAME?.value,
			name: "organizationName",
		});
	}

	if (inputs?.YTUNNUS?.value) {
		extraUserSettings.push({
			type: "text",
			value: inputs?.YTUNNUS?.value,
			name: "yTunnus",
		});
	}

	try {
		const registerResponse = await Axios({
			method: "post",
			url: `${API_Server}/api/register`,
			params: {
				action: "addSubscriber",
				organizationId,
				emailAddress: inputs?.EMAIL?.value,
				userPassword: inputs?.PASSWORD?.value,
				...(inputs?.PHONE?.value ? { phoneNumber: inputs?.PHONE?.value } : "-"),
				...(inputs?.CITY?.value ? { cityName: inputs?.CITY?.value } : "-"),
				...(inputs?.DATEOFBIRTH?.value ? { dateOfBirth: inputs?.DATEOFBIRTH?.value } : "-"),
				...(inputs?.COUNTRY?.value
					? {
							countryId: countries.find((country) => country.name === inputs?.COUNTRY?.value).id,
					  }
					: "-"),
				...(inputs?.FIRSTNAME?.value ? { firstName: inputs?.FIRSTNAME?.value } : "-"),
				...(inputs?.LASTNAME?.value ? { lastName: inputs?.LASTNAME?.value } : "-"),
				...(inputs?.ADDRESS?.value ? { address1: inputs?.ADDRESS?.value } : "-"),
				...(inputs?.POSTALCODE?.value ? { postalCode: inputs?.POSTALCODE?.value } : "-"),
				...(extraUserSettings.length > 0
					? { extraUserSettings: JSON.stringify(extraUserSettings) }
					: {}),
				...(role ? { role: role } : { role: "ismsubscriber" }),
			},
		});

		console.log("Register: ", registerResponse);
		return registerResponse;
	} catch (err) {
		console.log(err);
	}
};

const changePassword = async (
	organizationId,
	key,
	userId,
	newPassword,
	confirmPassword,
	oldPassword,
	userToken,
	admin
) => {
	const token = createChangePasswordToken(
		organizationId,
		key,
		userId,
		newPassword,
		confirmPassword
	);

	try {
		// const changePasswordResponse = await Axios.get(
		//   `${API_Server_MY}/api/user?action=changePassword&organizationId=${organizationId}&userId=${
		//     admin ? admin : userId
		//   }&newPassword=${newPassword}&confirmPassword=${confirmPassword}&token=${token}&oldPassword=${oldPassword}&userToken=${userToken}`
		// );

		let url = `${API_Server}/api/user?action=changePassword`;
		const changePasswordResponse = await Axios.get(url, {
			params: {
				organizationId,
				userId,
				newPassword,
				confirmPassword,
				token,
				oldPassword,
				userToken,
			},
		});

		console.log("ChangePassword: ", changePasswordResponse);
		return changePasswordResponse;
	} catch (err) {
		console.log(err);
		return err;
	}
};

// Update user
const updateUser = async (
	userId,
	userToken,
	organizationId,
	key,
	firstName,
	lastName,
	phoneNumber,
	countryId,
	regionId,
	cityName,
	postalCode,
	eMail
) => {
	const token = createAccountToken(
		userId,
		organizationId,
		key,
		firstName,
		lastName,
		phoneNumber,
		countryId,
		regionId,
		cityName,
		postalCode
	);

	try {
		const updateResponse = await Axios.get(
			`${API_Server}/api/user?action=updateUser&organizationId=${organizationId}&userToken=${userToken}&firstName=${firstName}&lastName=${lastName}&emailAddress=${eMail}&countryId=${countryId}&regionId=${regionId}&postalCode=${postalCode}&cityName=${cityName}&phoneNumber=${phoneNumber}&token=${token}`
		);
		console.log("updateUser: ", updateResponse);
		return updateResponse;
	} catch (err) {
		console.log(err);
	}
};

// Get user data
const getUser = async (userToken, organizationId) => {
	try {
		const getUserResponse = await Axios.get(
			`${API_Server}/api/user?action=getUserProfile&organizationId=${organizationId}&userToken=${userToken}`
		);
		console.log("getUser: ", getUserResponse);
		return getUserResponse;
	} catch (err) {
		console.log(err);
	}
};
//get bought tickets
export const getUserTickets = async (organizationId, userToken, languageId) => {
	try {
		let params = {
			action: "getUserTickets",
			organizationId,
			userToken,
			languageId,
		};
		let url = `${API_Server}/api/user`;

		const res = await Axios.get(url, { params });
		console.log(`res get tickets`, res);
		return res;
	} catch (error) {
		console.log(error);
		return error;
	}
};

// Get user data
const searchAssets = async (keyword, user, organizationId, language) => {
	try {
		const getSearchResponse = await Axios.get(
			`${API_Server}/api/search/assets?action=searchAssets`,
			{
				params: {
					organizationId,
					keyword: keyword,
					...(user?.userToken ? { userToken: user?.userToken } : {}),
					...(language ? { languageId: language } : {}),
					...(user?.userId ? { userId: user?.userId } : {}),
				},
			}
		);

		console.log("searchAsset: ", getSearchResponse);
		return getSearchResponse;
	} catch (err) {
		console.log(err);
	}
};
const getPlayerConfig = async (organizationId, channelID) => {
	try {
		const res = await Axios.get(
			`${API_Server}/api/applications?action=getAppConfig&appId=133485121`
		);
		return res.data;
	} catch (error) {
		console.log(error);
	}
};

// Get organizations packages based on given object (if no object given it will fetch all packages)
const getPackages = async (organizationId, lang, objectId, userToken) => {
	// API_Server = '${API_Server}';

	if (checkArguments(organizationId, lang)) {
		try {
			const params = {
				action: "getPackages",
				organizationId,
				// languageId: lang,
			};
			if (objectId > 0) {
				params.objectId = objectId;
			}
			if (userToken) {
				params.userToken = userToken;
			}
			const packagesResponse = await Axios.get(`${API_Server}/api/packages`, {
				params,
			});
			console.log("Org packages: ", packagesResponse);
			return packagesResponse.data;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get all shopping categories for organization
const getShoppingCategories = async (organizationId, lang) => {
	if (checkArguments(organizationId, lang)) {
		try {
			const params = {
				action: "getShoppingCategories",
				organizationId,
			};
			const shoppingCategoriesResponse = await Axios.get(`${API_Server}/api/packages`, { params });
			console.log("Shopping Cats: ", shoppingCategoriesResponse);
			return shoppingCategoriesResponse.data;
		} catch (err) {
			console.log(err);
		}
	}
};

// Get organizations payment methods
const getPaymentMethods = async (organizationId) => {
	// API_Server = '${API_Server}';

	try {
		const params = {
			action: "getPaymentMethods",
			organizationId,
		};
		const paymentMethodsResponse = await Axios.get(`${API_Server}/api/payment/methods`, { params });
		console.log("Payment methods: ", paymentMethodsResponse);
		const sortPayment = paymentMethodsResponse?.data.paymentMethods.sort((a, b) => a.id - b.id);
		console.log("sortPayment", sortPayment);
		return sortPayment;
	} catch (err) {
		console.log(err);
	}
};

//get payment url
const getPaymentUrl = async (
	userToken,
	organizationId,
	packageId,
	paymentMethodId,
	userEmail,
	handlerUrl,
	quantity
) => {
	console.log("organiId: ", organizationId);
	try {
		const params = {
			action: "initPurchase",
			organizationId: settings.organization.organizationId,
			// subOrganizationId: organizationId,
			packageId,
			paymentMethodId,
			handlerUrl,
			version: "new",
		};
		if (quantity > 1) {
			params.quantity = quantity;
			params.userEmail = userEmail;
		} else {
			params.userToken = userToken;
		}
		console.log(params);
		const paymentUrlResponse = await Axios.get(`${API_Server}/api/purchase`, {
			params,
		});

		console.log("Url", paymentUrlResponse);
		return paymentUrlResponse.data?.paymentData?.data;
	} catch (err) {
		console.log(err);
	}
};

// return from bambora payment
const purchasePackage = async (userToken, oldParams) => {
	try {
		let params = oldParams;
		params.userToken = userToken;
		params.action = "return";

		const purchasePackageResponse = await Axios.get(`${API_Server}/api/purchase/return`, {
			params,
		});

		console.log("PP: ", purchasePackageResponse);
		return purchasePackageResponse.data;
	} catch (err) {
		console.log(err);
	}
};

// Try to make Voucher purchase
const voucherPurchase = async (
	userToken,
	languageId,
	organizationId,
	productId,
	voucherCode,
	quantity,
	usedByEmail
) => {
	try {
		const params = {
			userToken,
			action: "activateVoucher",
			voucherCode,
			languageId,
			productId,
			usedDate: new Date().getTime(),
			organizationId,
			// quantity,
			usedByEmail,
		};
		console.log("PAR: ", params);
		const voucherPurchaseResponse = await Axios.get(`${API_Server}/api/purchase`, { params });
		console.log("VPR: ", voucherPurchaseResponse);
		return voucherPurchaseResponse;
	} catch (err) {
		console.log(err);
	}
};

// checking ticket number
const checkTicketNumber = async (eventId, ticketNumber) => {
	const paymentUrlResponse = await Axios.get(
		`${API_Server}/api/events/access?action=eventAccess&eventId=${eventId}&ticket=${ticketNumber}`
	);
	console.log(`checkTicket`, paymentUrlResponse);
	return paymentUrlResponse;
};
export const requestResetPassword = async (emailAddress, organizationId, role, token) => {
	let url = `${API_Server}/api/user?action=resetPassword`;
	const requestResetPasswordResponse = await Axios.get(url, {
		params: {
			organizationId,
			emailAddress,
			role,
			token,
		},
	});

	console.log("requestResetPassword response: ", requestResetPasswordResponse);
	return requestResetPasswordResponse;
};

export const validatePasswordResetToken = async (token) => {
	let url = `${API_Server}/api/user?action=validatePasswordToken`;
	const res = await Axios.get(url, {
		params: {
			token,
		},
	});

	console.log("validatePasswordResetToken response: ", res);
	return res;
};

export const resetPasswordChange = async (newPassword, confirmPassword, token) => {
	let url = `${API_Server}/api/user?action=setNewPassword`;
	const res = await Axios.get(url, {
		params: {
			newPassword,
			confirmPassword,
			token,
		},
	});

	console.log("reset password response: ", res);
	return res;
};

export {
	getCategories,
	getRootSubCategories,
	getSubCategories,
	getSeries,
	getLiveNowEvents,
	getEventsCategories,
	getSingleEvent,
	getAllEvents,
	getEventsCategoriesBeta,
	getAllEventsBeta,
	getChannelsBeta,
	getUpcomingEventsBeta,
	getChannels,
	getUpcomingEvents,
	getAssets,
	getSimiliar,
	getAsset,
	getEpisodes,
	getPromo,
	getBanner,
	getUser,
	authenticateUser,
	changePassword,
	registerUser,
	searchAssets,
	updateUser,
	getRecordings,
	getPlayerConfig,
	voucherPurchase,
	getShoppingCategories,
	getPackages,
	getPaymentUrl,
	purchasePackage,
	getPaymentMethods,
	checkTicketNumber,
	getLatestAssets,
	getTrendingAssets,
	findSubOrganizationSecret,
};
